import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import i18n from './i18u'
import myUser from './myUser'

import axios from 'axios'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle'

// import vue3GoogleLogin from 'vue3-google-login'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
const vuetify = createVuetify({
    components,
    directives,
})




// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
// axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'POST, PATCH, PUT, DELETE, OPTIONS';
// axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Access-Control-Allow-Headers, Content-Type, Authorization';
axios.defaults.headers.common['Content-type'] = 'application/json';
// axios.defaults.headers.common['Access-Control-Allow-Credentials'] = 'true';
// axios.defaults.withCredentials = true;
axios.defaults.baseURL = 'https://www.musa-cash.com/aaa/api_web/';

const app = createApp(App)

app.use(router)
app.use(i18n)
app.use(myUser)
app.use(vuetify)

// app.use(vue3GoogleLogin, {
//     clientId: '64992942768-e1t7nh47mod4hdr8mf9d1ilna5rv7gi6.apps.googleusercontent.com'
// })

app.mount('#app')


// createApp(App).use(router).use(i18n).use(myUser).use(vuetify).use(vue3GoogleLogin, {
//     clientId: '64992942768-e1t7nh47mod4hdr8mf9d1ilna5rv7gi6.apps.googleusercontent.com'
// }).mount('#app')
// createApp(App).use(router).use(i18n).use(myUser).use(bootstrap).mount('#app')
